import React, {Component} from "react";
import { Button, Card, CardHeader, Col, Container, Row } from "react-bootstrap";
import CommonService from "../services/common.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint, faSpinner } from "@fortawesome/free-solid-svg-icons";
import signalDispatcherInstance from "../utils/signalDispatcher";
import userEventService from "../services/user-event.service";
import QRCode from "react-qr-code";

let common = new CommonService();

interface QRPageState {
    orderID: string;
    codes: Array<any>;
    translations: Record<string, any>;
}


class QRPage extends Component<{}, QRPageState> {
    constructor(props: any) {
        super(props);
        const searchParams = new URLSearchParams(window.location.search);
        const orderID = searchParams.get('id'); 
        this.state = {
            orderID: orderID ? orderID : '',
            codes: [],
            translations: JSON.parse(localStorage.getItem('translations') || '[]'),
        };
    }

    componentDidMount(): void {
        userEventService.sendEvent('page_view', 'qr_page_open', { orderID: this.state.orderID });
        const timer = setInterval(() => {
            common.getQRCodes(this.state.orderID).then((result: any) => {
                if (result && result.length > 0) {
                    this.setState({ codes: result });
                    clearInterval(timer);
                }
            });
        }, 4000);
    }

    codesRendered(): boolean {
        return this.state.codes && this.state.codes.length > 0;
    }

    print() {
        window.print();
    }

    render() {
        return (
            <>
                <Container className="oc-mainpage">
                    <Row>
                        {!this.codesRendered() && 
                        <Col key={'pageContent_pending'} lg={12} md={12} sm={12} xs={12}>
                            <h2>
                                <FontAwesomeIcon icon={faSpinner} spin />&nbsp;{this.state.translations.filter((item: any) => item.setting_name === 'WAIT_FOR_CODES')[0]?.setting_value_text}
                            </h2>
                            <p style={{ marginTop: '32px' }}>
                                {this.state.translations.filter((item: any) => item.setting_name === 'WAIT_FOR_CODES_TEXT1')[0]?.setting_value_text}
                            </p>
                            <p className="highlight">
                                {this.state.translations.filter((item: any) => item.setting_name === 'WAIT_FOR_CODES_TEXT2')[0]?.setting_value_text}
                            </p>
                        </Col>
                        }
                        {this.codesRendered() && 
                        <Col key={'pageContent_completed'} lg={12} md={12} sm={12} xs={12}>
                            <h2 className="no-print">
                                {this.state.translations.filter((item: any) => item.setting_name === 'CODES_OK')[0]?.setting_value_text}
                                <Button onClick={() => this.print()} variant="primary" className="oc-btn-print"><FontAwesomeIcon icon={faPrint}></FontAwesomeIcon> {this.state.translations.filter((item: any) => item.setting_name === 'PRINT_BTN')[0].setting_value_text}</Button>
                            </h2>
                            <p style={{ marginTop: '32px' }}>
                                <Row className="qr-print-grid">
                                {this.state.codes && this.state.codes.map((codeObj: any) => (
                                    <Col lg={3} md={6} sm={12} xs={12} className="qr-print-item" key={codeObj.id}>
                                        <Card>
                                            <CardHeader>{codeObj.label}</CardHeader>
                                            <Card.Body>
                                                <QRCode value={codeObj.id} style={{ height: "auto", maxWidth: "100%", width: "100%" }} />
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))}
                                </Row>
                            </p>
                        </Col>
                        }
                    </Row>
                </Container>
            </>
        );
    }
}

export default QRPage;